/* GASSISA
=========================================================================================
* Descripción: Traslados entre almacenes/exhibidores con captura Redis-first.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/09/2026 | LIC. José Luis Aragón C.                       | Sin localStorage; lector estilo
*              |            |                                  | Conteos + cola; buffer Redis con
*              |            |                                  | gate de existencia; buscador por
*              |            |                                  | méquina PE/TR; autofinado 45s
*      2       | 23/09/2026 | LIC. José Luis Aragón C.                       | Sin existencias abajo (como original)
*      3       | 23/09/2026 | LIC. José Luis Aragón C.                       | Silencioso no bloquea edición;
*              |            |                                  | todo cambio habilita GUARDAR
 *      4       | 25/09/2026 | LIC. José Luis Aragón C.                       | Filas lineales (renglón por beep);
 *              |            |                                  | autoguardado antes de aplicar;
 *              |            |                                  | Sol/Exis en sin existencias
 *      5       | 26/09/2026 | Lic. José Luis Aragón Cervantes  | Nuevo/Guardar sin modal de progreso
 *              |            |                                  | (0-99 exclusivo de Aplicar)
 *      6       | 04/10/2026 | LIC. José Luis Aragón C.                       | Mecénica Salidas: guard central
 *              |            |                                  | + dirty + autofinado 45s; TR
 *              |            |                                  | bloquea todo excepto buscar;
 *              |            |                                  | imprimir siempre desde SQL
 *      7       | 04/10/2026 | LIC. José Luis Aragón C.                       | Scroll centrado a media ventana;
 *              |            |                                  | sort por click + reindex para
 *              |            |                                  | flechas sobre orden visible
 *      8       | 05/10/2026 | LIC. José Luis Aragón C.                       | PDF en modal vista previa (no
 *              |            |                                  | descarga); ticket tal cual
 *              |            |                                  | pre-generado + fallback SQL
 *      9       | 05/10/2026 | LIC. José Luis Aragón C. (port tenant)         | Fix bugs (paridad original Rev 9,
 *              |            |                                  | 100% RequestContext): totalizador
 *              |            |                                  | = length + reindex 1..N tras
 *              |            |                                  | eliminar (0/1/N); Guardar sin
 *              |            |                                  | doble error (dirty no-op ->
 *              |            |                                  | EDITAR estable); vista previa y
 *              |            |                                  | comprobante en pestaña nueva vía
 *              |            |                                  | GetFile/PostFileRequest
 *              |            |                                  | openInNewTab; progreso 0-99
 *              |            |                                  | visible al aplicar; guard
 *              |            |                                  | silencioso + validación conteo
 *              |            |                                  | Redis/SQL antes de aplicar
 *      10      | 05/10/2026 | LIC. José Luis Aragón C. (port tenant)         | Fix grave mezcla Redis (paridad
 *              |            |                                  | original Rev 10, 100%
 *              |            |                                  | RequestContext, sin fetch
 *              |            |                                  | directo): cola con generación,
 *              |            |                                  | Nuevo/Aplicar limpian buffer +
 *              |            |                                  | verifican lista vacía; post-
 *              |            |                                  | aplicar PE desbloqueado; borrar
 *              |            |                                  | recarga ids reales; pagehide sin
 *              |            |                                  | fetch (JWE intacto, solo
 *              |            |                                  | autofinado/unmount)
 *      11      | 08/10/2026 | LIC. José Luis Aragón C.                       | Nuevo desde vista bloqueada TR/CA
 *              |            |                                  | libera vista + Redis y pide folio
 *              |            |                                  | disponible (no aborta si nuevo
 *              |            |                                  | falla); select no degrada TR a PE;
 *              |            |                                  | verificación preserveUi no invasiva
 * ---------------------------------------------------------------------------------------
 */
import TextField from "../ui/TextField";
import Autocomplete from "../ui/Autocomplete";
import React, { Fragment, useEffect, useMemo, useState, useRef } from 'react';
import { Box, IconButton } from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopy from "@mui/icons-material/ContentCopy";
import { copiarTexto } from "../../helpers/portapapeles";

import { useInventarios } from '../../context/Inventarios/InventariosContext';
import { useLayout } from '../../context/System/LayoutContext';
import { speakText } from "../../settings/utils";
import {
    apiTrasladosAplicarMasivo, apiImprimirTraslado,
    apiTrasladosEliminaPartida, apiTrasladosEliminaTrasladoPC, apiFolioDisponibleTraslados,
    apiTrasladosGuardarTemporales, apiTrasladosCapturaLista, apiTrasladosValidar,
    apiTrasladosNuevo, apiTrasladosCapturaEliminarPartida, apiTrasladosCapturaEliminarTodo,
    apiTrasladosCtx, apiTrasladosCtxGuardar, apiTrasladosCapturarRedis, apiReporteTrasladosPeriodo,
    apiLimpiezaNuevo,
} from "../../settings/ApiConfig";

import MnuTrasladosAlmacenesExhibidoresActions from './MnuTrasladosAlmacenesExhibidoresActions.jsx'
import SizeSoftXLayoutForm from "../leyout/SizeSoftXLayoutForm.jsx"
import SizeSoftXConfirmDialog from '../leyout/SizeSoftXConfirmDialog.jsx'
import SizeSoftXTableVentas from '../leyout/SizeSoftXTableVentas.jsx'
import SizeSoftXLectorCodigoBarrasEntradas from "../leyout/SizeSoftXLectorCodigoBarrasEntradas.jsx"
import ModalBuscarArticulosParaVenta from '../herramientas/ModalBuscarArticulosParaVenta.jsx'
import ModalBuscarTraslados from './ModalBuscarTraslados.jsx'
import FrmLoginValidate from "../administracion/FrmLoginValidate";
import ModalStatusWaitingProcess from '../utils/ModalStatusWaitingProcess.jsx';
import { useFormTabLock } from "../../hooks/useFormTabLock";

import { useSesion } from '../../context/System/SesionContext';
import { useRequest } from '../../context/System/RequestContext';

// Rev 1 (23/09/2026): sin localStorage. El respaldo es el buffer Redis del
// backend (72h) + SQL; origen/destino/folio viven en la llave ctx por PC.
// Rev 6 (04/10/2026): estandarizado con Salidas — autofinado cada 45s con
// dirty flag (solo dispara si hubo cambios), guard central antes de cada
// acción crítica e impresión siempre desde SQL (previo finado Redis→SQL).
const AUTOFINADO_MS = 45000;

export default function FrmTraslados() {
    const { isLocked: isFormLocked } = useFormTabLock('traslados', {
        title: 'Traslados',
        onLockDetected: (info) => {
            console.warn(`El formulario de ${info?.title || 'Traslados'} ya está abierto en otra pestaña`);
        }
    });

    const tableRef = useRef(null);
    const listaTrasladosDataRef = useRef(null);
    // Rev 7: orden visible + índice de navegación (patrón Salidas/Entradas).
    // sortedDataRef guarda el orden que realmente se ve (tras click en
    // columnas); posNavRef es la posición dentro de ese orden para que las
    // flechas avancen 1 a 1 sin alterar datos. Se reindexa en cada sort.
    const sortedDataRef = useRef([]);
    const posNavRef = useRef(-1);
    // Contador de orden en memoria (antes en localStorage).
    const captureIndexRef = useRef(1);
    const getNextCaptureIndex = () => {
        const idx = captureIndexRef.current;
        captureIndexRef.current += 1;
        return idx;
    };
    const [folioTraslado, setFolioTraslado] = useState(0);
    const [titleActionSave, setTitleActionSave] = useState("NUEVA");


    const { parametrosCajaForm, usuario, tipoUsuario } = useSesion();
    // Port tenant: todo el tréfico por RequestContext (con reintento de
    // auth). Los PDF usan GetFile/PostFileRequest con openInNewTab (pestaña
    // nueva nativa del tenant); nada de fetch directo en este módulo.
    const { PostRequest, DeleteRequest, GetRequest, GetFileRequest, PostFileRequest } = useRequest();
    const { handleOpenAlert } = useLayout();

    const {
        handleObtenerAlmacenesExhibidores,
        listaAlmacenesExhibidoresGeneral,
        errorDestino,
        setErrorDestino,
        almacenExhibidorOrigen, almacenExhibidorDestino,
        setAlmacenExhibidorOrigen, setAlmacenExhibidorDestino,
        handleClickRegresarMainDashboard,
        handleCloseModalBuscarArticulos,
        handleAbrirModalBuscarArticulos,
        handleCerrarValidarAccesoTraslados,
        openModalValidarAcceso,
        handleAbrirValidarAccesoTraslados,
        // Rev 1: catélogo oculto para resolve O(1) del lector.
        handleCargarCatalogoCbarras,
        resolverArticuloCbarrasLocal,
        handleResolverCodigoEntradas,
    } = useInventarios();

    const pc = parametrosCajaForm.caja.trim();

    const [listaTrasladosData, setListaTrasladosData] = useState([]);
    listaTrasladosDataRef.current = listaTrasladosData;

    const [listaSinExistencias, setListaSinExistencias] = useState([]);
    // Cola de escaneos en memoria (no se pierde ni se atora ninguna lectura).
    // Rev 10 (port tenant): cada entrada guarda su generación de folio. Si el
    // folio cambia (Nuevo/Aplicar/Eliminar/Buscar) la generación se incrementa
    // y los scans viejos encolados se descartan en vez de mezclarse en el
    // folio nuevo. Todo en memoria + RequestContext; sin fetch directo (JWE).
    const colaScanRef = useRef([]);
    const procesandoScanRef = useRef(false);
    const generacionFolioRef = useRef(0);
    const guardandoRef = useRef(false);
    const vaciarColaScans = () => { colaScanRef.current = []; };
    const avanzarGeneracionFolio = () => {
        generacionFolioRef.current += 1;
        vaciarColaScans();
    };
    // Rev 10 (port tenant): espera a que la cola termine antes de cambiar de
    // folio (Nuevo/Aplicar/Eliminar). Solo timers; sin red, sin fetch (JWE).
    const esperarColaScans = async (timeoutMs = 8000) => {
        const t0 = Date.now();
        try {
            while ((colaScanRef.current.length > 0 || procesandoScanRef.current) && Date.now() - t0 < timeoutMs) {
                await new Promise((r) => setTimeout(r, 100));
            }
        } catch {}
    };

    const [partidaTrasladoSeleccionada, setPartidaTrasladoSeleccionada] = useState(null);
const [isTrasladoBlocked, setIsTrasladoBlocked] = useState(false);
    const [isEdicionBloqueada, setIsEdicionBloqueada] = useState(false);
    // Rev 6: status del movimiento (PE/TR/CA) + dirty flag para autofinado.
    // Igual que Salidas: TR/CA bloquea toda edición; solo Buscar/Salir siguen vivos.
    const [statusTraslado, setStatusTraslado] = useState("PE");
    const dirtyRef = useRef(false);
    const marcarSucio = () => { dirtyRef.current = true; };
    const limpiarSucio = () => { dirtyRef.current = false; };
    const [openProgressModal, setOpenProgressModal] = useState(false);
    const [openConfirmEliminarTraslado, setOpenConfirmEliminarTraslado] = useState(false);
    const [totalRegistrosProgress, setTotalRegistrosProgress] = useState(0);
    const [mostrarBuscadorArticulos, setMostrarBuscadorArticulos] = useState(false);
    // Rev 9 (port tenant): sin visor modal. Vista previa y comprobante en
    // otra pestaña vía GetFile/PostFileRequest openInNewTab (RequestContext).

    // Rev 6: derivados estilo Salidas. movimientoBloqueado manda sobre los
    // flags en memoria; en TR/CA nada es editable excepto Buscar/Salir.
    const statusTrasladoNormalizado = String(statusTraslado || "").trim().toUpperCase();
    const statusPartidaCabecera = String(
        listaTrasladosData?.[0]?.statusentradasalida
        ?? listaTrasladosData?.[0]?.statustraslado
        ?? listaTrasladosData?.[0]?.status
        ?? listaTrasladosData?.[0]?.sStatusTraslado
        ?? ""
    ).trim().toUpperCase();
    const movimientoBloqueado =
        statusTrasladoNormalizado === "TR" ||
        statusTrasladoNormalizado === "CA" ||
        statusPartidaCabecera === "TR" ||
        statusPartidaCabecera === "CA" ||
        isTrasladoBlocked;
    const modoEdicionTraslado = titleActionSave === "GUARDAR";
    const funcionalidadBloqueadaTraslado = movimientoBloqueado || isEdicionBloqueada || !modoEdicionTraslado;

    const focusLectorCodigoBarras = () => {
        setTimeout(() => {
            const input = document.getElementById('txtCodigoBarras');
            if (input) {
                input.focus();
                input.select();
            }
        }, 0);
    };

    const handleRowClickTraslados = (row) => {
        setPartidaTrasladoSeleccionada(row);
        // Rev 7: sincronizar índice de navegación con la fila clickeada
        // dentro del orden visible actual.
        try {
            const orden = ordenVisible();
            const idx = orden.findIndex((r) => r && row && r.id === row.id);
            if (idx >= 0) posNavRef.current = idx;
        } catch {}
        focusLectorCodigoBarras();
    };

    const focusFiltroBuscadorArticulos = () => {
        setTimeout(() => {
            const filtroInput = document.querySelector('input[name="Filtro"]');
            if (filtroInput) {
                filtroInput.focus();
                filtroInput.select();
            }
        }, 150);
    };

    // Rev 7: scroll robusto (patrón Salidas/Entradas). No se asume que el
    // scroller sea el MuiTableContainer (puede no tener scroll propio porque
    // .body_traslados es quien desplaza); se busca el ancestro con scroll
    // real y se centra la fila a media ventana. Con reserva del pie fijo
    // para que la última fila no quede tapada.
    const buscarScrollerReal = (el) => {
        if (!el) return null;
        let n = el.parentElement;
        while (n) {
            try {
                if (n.scrollHeight > n.clientHeight + 1) return n;
            } catch {}
            n = n.parentElement;
        }
        return null;
    };

    const reservaPieFijo = () => {
        try {
            const footer = document.getElementById('fixed-footer-traslados');
            return (footer?.offsetHeight || 70) + 12;
        } catch { return 82; }
    };

    const desplazarFilaSeleccionada = (centrar = true) => {
        const selectedRow = tableRef.current?.querySelector('tr.row');
        if (selectedRow) {
            centrarFilaEnScroller(selectedRow, centrar);
            return;
        }
        // Fallback: la fila seleccionada puede estar fuera de tableRef si el
        // DOM cambió; buscarla por id de selección.
        try {
            const sel = partidaTrasladoSeleccionada;
            if (!sel) return;
            const orden = ordenVisible();
            const idx = orden.findIndex((r) => r && r.id === sel.id);
            if (idx >= 0) {
                const el = document.querySelector(`#row-${idx}`);
                if (el) centrarFilaEnScroller(el, centrar);
            }
        } catch {}
    };

    const centrarFilaEnScroller = (el, centrar = true) => {
        if (!el) return;
        const scroller = buscarScrollerReal(el);
        if (!scroller) {
            try { el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' }); } catch {}
            return;
        }
        try {
            const sr = scroller.getBoundingClientRect();
            const r = el.getBoundingClientRect();
            if (centrar) {
                // Media ventana: centro del scroller menos centro de la fila.
                const delta = (r.top - sr.top) - ((sr.height - r.height) / 2);
                let top = scroller.scrollTop + delta;
                // No tapar con el pie fijo al centrar cerca del final.
                const maxTop = Math.max(scroller.scrollHeight - scroller.clientHeight, 0);
                top = Math.min(Math.max(top, 0), maxTop);
                scroller.scrollTo({ top, behavior: 'smooth' });
            } else {
                const reserva = reservaPieFijo();
                const limiteInferior = sr.bottom - reserva;
                if (r.bottom > limiteInferior) {
                    scroller.scrollTo({ top: scroller.scrollTop + (r.bottom - limiteInferior), behavior: 'smooth' });
                } else if (r.top < sr.top + 4) {
                    scroller.scrollTo({ top: scroller.scrollTop - (sr.top - r.top + 4), behavior: 'smooth' });
                }
            }
        } catch {}
    };

    // Rev 7: orden visible para navegación por flechas (igual que Salidas).
    const ordenVisible = () => {
        const lista = Array.isArray(listaTrasladosData) ? listaTrasladosData : [];
        if (sortedDataRef.current.length === lista.length && lista.length > 0) {
            return sortedDataRef.current;
        }
        return lista;
    };
    const aplicarOrdenVisible = (sorted) => {
        const orden = Array.isArray(sorted) ? sorted : [];
        sortedDataRef.current = orden;
        if (orden.length === 0) { posNavRef.current = -1; return; }
        try {
            const sel = partidaTrasladoSeleccionada;
            const idx = sel ? orden.findIndex((r) => r && sel && r.id === sel.id) : -1;
            posNavRef.current = idx >= 0 ? idx : 0;
        } catch { posNavRef.current = 0; }
    };

    // Rev 7: sin scroll general, solo desplaza la tabla (esténdar Salidas).
    // Bloquea el overflow del dashboard mientras el módulo esté activo para
    // que exista una sola barra vertical (la del detalle).
    useEffect(() => {
        const el = document.querySelector('.sizesoftx-dashboard .content');
        if (!el) return;
        const prevY = el.style.overflowY;
        const prevX = el.style.overflowX;
        el.style.overflowY = 'hidden';
        el.style.overflowX = 'hidden';
        return () => {
            el.style.overflowY = prevY;
            el.style.overflowX = prevX;
        };
    }, []);

    useEffect(() => {
        if (isFormLocked) {
            alert("El formulario de Traslados ya está abierto en otra pestaña del navegador.\n\nPor favor, cierre la otra ventana o pestaña para continuar.");
            setTimeout(() => {
                handleClickRegresarMainDashboard();
            }, 900);
        }
    }, [isFormLocked]);

    useEffect(() => {
        listaTrasladosDataRef.current = listaTrasladosData;
if (listaTrasladosData.length > 0) {
            setIsTrasladoBlocked(false);
        }
    }, [listaTrasladosData]);

    // Rev 1 (23/09/2026): recuperación por cambio de PC vía localStorage
    // eliminada. El buffer Redis + SQL por PC lo hacen innecesario.
    const guardarCtxTraslados = async (origen, destino, folio) => {
        try {
            await PostRequest({
                url: apiTrasladosCtxGuardar,
                body: {
                    pc: pc.trim(),
                    origen: String(origen || "").trim(),
                    destino: String(destino || "").trim(),
                    folio: Number(folio) || 0,
                },
            });
        } catch {}
    };

    const cargarCtxTraslados = async () => {
        try {
            const url = apiTrasladosCtx.replace("{pc}", encodeURIComponent(pc.trim()));
            const response = await GetRequest({ url });
            const ctx = response?.result;
            if (!ctx) return null;
            if (ctx.origen) setAlmacenExhibidorOrigen({ nombre: String(ctx.origen).trim() });
            if (ctx.destino) setAlmacenExhibidorDestino({ nombre: String(ctx.destino).trim() });
            return ctx;
        } catch {
            return null;
        }
    };

    const cargarListaTraslados = async (opts = {}) => {
        try {
            const url = apiTrasladosCapturaLista.replace("{pc}", encodeURIComponent(pc.trim()));
            const response = await GetRequest({ url, loader: opts.silent ? undefined : "Consultando traslado..." });
            if (response?.hasError || response?.HasError) {
                if (!opts.preserveUi) setListaTrasladosData([]);
                return [];
            }
            const rows = (Array.isArray(response?.result) ? response.result : []).map((r, idx) => ({
                ...r,
                _captureIndex: idx + 1,
            }));
            captureIndexRef.current = rows.length + 1;
            setListaTrasladosData(rows);
            listaTrasladosDataRef.current = rows;
            // Rev 11: verificación no invasiva (Nuevo/Aplicar/limpiarBuffer).
            // Con preserveUi solo se regresan las filas sin mutar
            // status/título/bloqueo/selección, para no contaminar el reset.
            if (opts.preserveUi) return rows;
            if (rows.length > 0) {
                // Rev 6: sincronizar cabecero estilo Salidas (status manda).
                const st = String(
                    rows[0]?.statusentradasalida
                    ?? rows[0]?.statustraslado
                    ?? rows[0]?.status
                    ?? rows[0]?.sStatusTraslado
                    ?? "PE"
                ).trim().toUpperCase() || "PE";
                setStatusTraslado(st);
                if (st === "TR" || st === "CA") {
                    setTitleActionSave("EDITAR");
                    setIsEdicionBloqueada(true);
                } else {
                    setPartidaTrasladoSeleccionada(rows[rows.length - 1]);
                    setTitleActionSave("GUARDAR");
                }
                limpiarSucio();
            } else {
                setStatusTraslado("PE");
            }
            return rows;
        } catch {
            setListaTrasladosData([]);
            return [];
        }
    };

    // Rev 1 (23/09/2026): inicialización Redis — catélogo oculto, contexto
    // (origen/destino/folio), folio y lista mezclada SQL+buffer.
    useEffect(() => {
        handleCargarCatalogoCbarras().catch(() => {});
    }, []);

    useEffect(() => {
        const inicializar = async () => {
            const ctx = await cargarCtxTraslados();
            let folio = Number(ctx?.folio) || 0;
            if (!folio) {
                try {
                    const response = await GetRequest({
                        url: apiFolioDisponibleTraslados.replace("{pc}", pc),
                        loader: "Verificando folio de traslados...",
                    });
                    if (!response?.HasError && !response?.hasError && response?.result) {
                        folio = Number(response.result);
                    }
                } catch {}
            }
            if (folio > 0) setFolioTraslado(folio);
            await cargarListaTraslados();
        };
        inicializar();
    }, [pc]);

    const normalizarAlmacenSeleccionado = (value) => {
        if (typeof value === "string") {
            const nombre = value.trim();
            return nombre ? { nombre } : null;
        }
        return value;
    };

    const guardarAlmacenexhibidorOrigen = (value) => {
        const almacenSeleccionado = normalizarAlmacenSeleccionado(value);
        if (almacenSeleccionado) {
            setAlmacenExhibidorOrigen(almacenSeleccionado);
            // Rev 1: permanencia en Redis (ctx por PC), sin localStorage.
            guardarCtxTraslados(
                almacenSeleccionado.nombre,
                almacenExhibidorDestino?.nombre || "",
                folioTraslado
            );
            setErrorDestino(almacenExhibidorDestino?.nombre === almacenSeleccionado.nombre);
            if (!movimientoBloqueado) marcarSucio();
            return almacenSeleccionado;
        }

        setErrorDestino(true);
        return null;
    };

    const handleChangeAlmacenexhibidorOrigen = (e, newValue) => {
        guardarAlmacenexhibidorOrigen(newValue);
        focusLectorCodigoBarras();
    };

    const handleInputChangeAlmacenexhibidorOrigen = (e, newInputValue, reason) => {
        if (reason === "clear") return;
        guardarAlmacenexhibidorOrigen(newInputValue);
    };

    const handleChangeAlmacenexhibidorDestino = (e, newValue) => {
        const almacenSeleccionado = normalizarAlmacenSeleccionado(newValue);
        if (almacenSeleccionado) {
            setAlmacenExhibidorDestino(almacenSeleccionado);
            // Rev 1: permanencia en Redis (ctx por PC), sin localStorage.
            guardarCtxTraslados(
                almacenExhibidorOrigen?.nombre || "",
                almacenSeleccionado.nombre,
                folioTraslado
            );
            setErrorDestino(almacenExhibidorOrigen?.nombre === almacenSeleccionado.nombre);
            if (!movimientoBloqueado) marcarSucio();
        } else {
            setErrorDestino(true);
        }
        focusLectorCodigoBarras();
    };

    // Rev 1 (23/09/2026): resolve O(1) en catélogo oculto -> capturar-redis.
    // El gate de existencia-origen vive en el backend (caché + confirmación
    // SQL); aquí no hay GET por escaneo ni localStorage.
    const resolverArticuloTraslado = async (codigobarras) => {
        const codigo = String(codigobarras || "").trim();
        if (!codigo) return null;
        const local = resolverArticuloCbarrasLocal(codigo);
        if (local) return local;
        return await handleResolverCodigoEntradas(codigo);
    };

    const capturarTrasladoRedis = async (articulo, codigoOriginal) => {
        const origen = almacenExhibidorOrigen?.nombre?.trim();
        const destino = almacenExhibidorDestino?.nombre?.trim();

        if (!origen || !destino) {
            handleOpenAlert("Seleccione almacén origen y destino");
            return null;
        }
        if (origen.toUpperCase() === destino.toUpperCase()) {
            handleOpenAlert("El origen y destino no pueden ser iguales");
            return null;
        }
        const result = await PostRequest({
            url: apiTrasladosCapturarRedis,
            body: {
                codigobarras: String(codigoOriginal || articulo?.codigobarras || "").trim(),
                clavearticulo: articulo?.clavearticulo || "",
                descripcion: articulo?.descripcion || "",
                medida: articulo?.medida || 0,
                factor: articulo?.factor || 1,
                almacenexhibidororigen: origen,
                almacenexhibidordestino: destino,
                pc,
                usuario,
            },
        });
        if (result?.hasError || result?.HasError || !result?.result) {
            handleOpenAlert(result?.message || "Error al capturar traslado");
            return null;
        }
        return result.result;
    };

    // Rev 10 (port tenant): limpia el buffer Redis de la PC vía RequestContext
    // (DeleteRequest + verificación con captura-lista). Sin esto quedaban
    // deltas huérfanos que se mezclaban en el folio nuevo. Sin fetch directo.
    // Rev 11: verificación con preserveUi para no mutar título/bloqueo/status.
    const limpiarBufferRedisTraslados = async () => {
        try {
            const urlBuf = apiTrasladosCapturaEliminarTodo.replace("{pc}", encodeURIComponent(pc.trim()));
            await DeleteRequest({ url: urlBuf });
        } catch {}
        try {
            const rows = await cargarListaTraslados({ silent: true, preserveUi: true });
            return !rows || rows.length === 0;
        } catch {
            return true;
        }
    };

    // Cola de escaneos en memoria: el lector encola sin esperar y el
    // procesador consume en serie (répido y sin perder lecturas).
    // Rev 10 (port tenant): se descarta todo scan de generación anterior
    // (folio ya terminado/nuevo) para no jalar lecturas del anterior.
    const procesarColaScans = async () => {
        if (procesandoScanRef.current) return;
        procesandoScanRef.current = true;
        try {
            while (colaScanRef.current.length > 0) {
                const entrada = colaScanRef.current.shift();
                const codigo = typeof entrada === "string" ? entrada : entrada?.codigo;
                const gen = typeof entrada === "string" ? generacionFolioRef.current : entrada?.gen;
                if (gen !== generacionFolioRef.current) continue;
                if (movimientoBloqueado || isEdicionBloqueada || isTrasladoBlocked) continue;
                const articulo = await resolverArticuloTraslado(codigo);
                if (gen !== generacionFolioRef.current) continue;
                if (!articulo) {
                    focusLectorCodigoBarras();
                    continue;
                }
                const captura = await capturarTrasladoRedis(articulo, codigo);
                if (gen !== generacionFolioRef.current) continue;
                await handleRegistrarArticuloTrasladoFromCollector(captura, articulo);
                focusLectorCodigoBarras();
            }
        } finally {
            procesandoScanRef.current = false;
            // Rev 10.1 (port tenant): la cola nunca retiene de més. Cada
            // entrada se extrae con shift al procesarla; al terminar se purgan
            // restos de generación vieja y queda en vacío hasta la próxima
            // captura. Si llegó algo nuevo al final, se reanuda (evita stall).
            // Solo memoria + RequestContext; sin fetch directo (JWE).
            try {
                const genActual = generacionFolioRef.current;
                if (colaScanRef.current.length > 0) {
                    colaScanRef.current = colaScanRef.current.filter((e) =>
                        typeof e === "string" ? true : e?.gen === genActual);
                }
            } catch {}
            if (colaScanRef.current.length > 0) {
                procesarColaScans().catch(() => {});
            } else {
                vaciarColaScans();
            }
        }
    };

    const handleColectorScanTraslados = (codigo) => {
        if (isEdicionBloqueada || isTrasladoBlocked || movimientoBloqueado) return;
        if (!codigo) return;
        colaScanRef.current.push({ codigo, gen: generacionFolioRef.current });
        // Rev 10.1 (port tenant): con catch; la cola se conserva y el finally
        // la reanuda/purga. Sin fetch directo.
        procesarColaScans().catch(() => {});
    };

    const normalizarMedidaKey = (value) => {
        const numberValue = Number(value);
        return Number.isFinite(numberValue) ? String(numberValue) : String(value ?? '').trim();
    };

    const getTrasladoKey = (item = {}) => [
        item.clavearticulo,
        normalizarMedidaKey(item.medida),
        item.almacenexhibidororigen,
        item.almacenexhibidordestino,
    ].map(value => String(value ?? '').trim().toUpperCase()).join('|');

    // Rev 4: filas LINEALES (un renglón por beep, sin fusionar por llave).
    // La suma por artículo+medida vive solo en la validación del backend
    // (gate vs existencia de ORIGEN en SQL); aquí cada captura se agrega.
    const actualizarListaTrasladosConCaptura = (partida, captura) => {
        const incremento = Number(captura?.factor ?? captura?.dFactor ?? partida?.factor ?? 1) || 1;
        // Rev 7: un solo folio de secuencia por renglón. Antes se llamaba
        // getNextCaptureIndex() dos veces (id temporal + _captureIndex) y el
        // "#" quedaba 2,4,6,8... Ahora es 1,2,3,4...
        const seq = getNextCaptureIndex();
        const itemNuevo = {
            ...partida,
            id: partida.id || -seq,
            cantidad: incremento,
            existenciaorigen: Number(partida.existenciaorigen ?? captura?.existenciaorigen ?? 0),
            existenciadestino: Number(partida.existenciadestino ?? captura?.existenciadestino ?? 0),
            _captureIndex: seq,
        };

        setListaTrasladosData(prev => {
            const updated = [...prev, itemNuevo];
            listaTrasladosDataRef.current = updated;
            return updated;
        });
        // Rev 6: todo cambio marca sucio para el autofinado de 45s.
        marcarSucio();

        return itemNuevo;
    };

const handleRegistrarArticuloTrasladoFromCollector = async (captura) => {
        if (!captura) return false;
        if (isEdicionBloqueada || movimientoBloqueado) return false;

        // El gate de existencia-ORIGEN ya lo aplicó el backend (SQL manda).
        if (!captura.registrado) {
            speakText(`NO PASO ARTICULO ${captura.descripcion || ""}`);
            const solicitado = Number(captura.solicitado ?? captura.cantidadtraslado ?? 0) || 0;
            const existencia = Number(captura.existenciaorigen ?? 0) || 0;
            handleOpenAlert(`Sin existencia en origen. Solicitado: ${solicitado}, Existencia: ${existencia}`);
            setListaSinExistencias(prev => ([...prev, {
                clavearticulo: captura.clavearticulo || '',
                descripcion: captura.descripcion || '',
                medida: captura.medida || '',
                solicitado,
                existenciaorigen: existencia,
            }]));
            return true;
        }

        const partida = captura.partida;
        if (partida) {
            speakText("SI PASO");
            const partidaRender = actualizarListaTrasladosConCaptura(partida, captura);
            setTitleActionSave("GUARDAR");
            setPartidaTrasladoSeleccionada(partidaRender);
        }
        return true;
    };

const handleArticuloSelecionado = async (dataArticulo, almacenSelecto) => {
        if (!dataArticulo || !almacenSelecto) return;
        if (isEdicionBloqueada || movimientoBloqueado) return;
        setMostrarBuscadorArticulos(false);
        const codigo = dataArticulo.codigobarras || dataArticulo.codigoBarras || "";
        const articulo = resolverArticuloCbarrasLocal(codigo)
            || await handleResolverCodigoEntradas(codigo)
            || {
                clavearticulo: dataArticulo.clavearticulo,
                descripcion: dataArticulo.descripcion,
                medida: dataArticulo.medida,
                factor: dataArticulo.factor || 1,
                pmvb: dataArticulo.pmvb || 0,
                costoventa: 0,
                codigobarras: codigo,
            };
        if (!articulo?.clavearticulo) {
            setTimeout(focusLectorCodigoBarras, 120);
            return;
        }
        const captura = await capturarTrasladoRedis(articulo, codigo);
        if (!captura) {
            setTimeout(focusLectorCodigoBarras, 120);
            return;
        }
        await handleRegistrarArticuloTrasladoFromCollector(captura);
        setTimeout(focusLectorCodigoBarras, 120);
    };

const handleEliminaPartidaTrasladoCaja = async (row) => {
        if (isEdicionBloqueada || movimientoBloqueado) return;
        const objetivoLocal = row || partidaTrasladoSeleccionada;
        if (!objetivoLocal) return;
        // Rev 10 (port tenant): finar primero y recargar ids reales vía
        // RequestContext. Sin recarga se borraba por id temporal en buffer
        // vacío y la fila SQL quedaba huérfana (reaparecía y se mezclaba).
        if (!(await guardarTrasladoSiHayCambios({ silent: true }))) return;
        let rowsSrv = [];
        try {
            rowsSrv = await cargarListaTraslados({ silent: true }) || [];
        } catch {
            rowsSrv = listaTrasladosDataRef.current || [];
        }
        let objetivoSrv = rowsSrv.find((r) => String(r?.id) === String(objetivoLocal?.id));
        if (!objetivoSrv) {
            try {
                const keyObj = getTrasladoKey(objetivoLocal);
                const candidatos = (rowsSrv || []).filter((r) => getTrasladoKey(r) === keyObj);
                objetivoSrv = candidatos.find((r) => Number(r?.cantidad) === Number(objetivoLocal?.cantidad))
                    || candidatos[0] || null;
            } catch { objetivoSrv = null; }
        }
        if (!objetivoSrv) {
            const reindexados = (rowsSrv || []).map((item, idx) => ({ ...item, _captureIndex: idx + 1 }));
            captureIndexRef.current = reindexados.length + 1;
            setListaTrasladosData(reindexados);
            listaTrasladosDataRef.current = reindexados;
            setPartidaTrasladoSeleccionada(reindexados.length > 0 ? reindexados[reindexados.length - 1] : null);
            setTitleActionSave(reindexados.length > 0 ? "GUARDAR" : "NUEVA");
            setIsEdicionBloqueada(false);
            if (reindexados.length === 0) { limpiarSucio(); }
            else marcarSucio();
            focusLectorCodigoBarras();
            return;
        }
        const id = objetivoSrv.id;

        // Rev 4: borrado por RENGLÓN (filas lineales). Id real (>0) = fila
        // SQL finada (borrado por id). Id temporal/negativo = renglón en
        // buffer agrupado: descuenta solo su cantidad (no toda la llave).
        if (Number(id) > 0) {
            try {
                const url = apiTrasladosEliminaPartida.replace("{pc}", pc).replace("{id}", id);
                await DeleteRequest({ url });
            } catch {}
        } else {
            try {
                const cantidadFila = Number(objetivoLocal.cantidad ?? objetivoSrv.cantidad) || 0;
                let urlBuf = apiTrasladosCapturaEliminarPartida
                    .replace("{pc}", encodeURIComponent(pc.trim()))
                    .replace("{clave}", encodeURIComponent(String(objetivoSrv.clavearticulo || "").trim()))
                    .replace("{medida}", objetivoSrv.medida ?? 0)
                    .replace("{origen}", encodeURIComponent(String(objetivoSrv.almacenexhibidororigen || "").trim()))
                    .replace("{destino}", encodeURIComponent(String(objetivoSrv.almacenexhibidordestino || "").trim()));
                if (cantidadFila > 0) urlBuf += `?cantidad=${cantidadFila}`;
                await DeleteRequest({ url: urlBuf });
            } catch {}
        }

        // Rev 10 (port tenant): recargar del servidor tras borrar vía
        // RequestContext (sin filtrar por id viejo) para no dejar fantasmas.
        let quedan = [];
        try {
            quedan = await cargarListaTraslados({ silent: true }) || [];
        } catch {
            quedan = (listaTrasladosDataRef.current || []).filter((item) => String(item.id) !== String(objetivoSrv.id));
        }
        // Rev 9: retotalizar + reindexar "#" a 1..N para que cuadre con el
        // totalizador. Si no queda nada: 0 y contador reiniciado.
        const reindexados = (quedan || []).map((item, idx) => ({ ...item, _captureIndex: idx + 1 }));
        captureIndexRef.current = reindexados.length + 1;
        setListaTrasladosData(reindexados);
        listaTrasladosDataRef.current = reindexados;
        setPartidaTrasladoSeleccionada(reindexados.length > 0 ? reindexados[reindexados.length - 1] : null);
        setTitleActionSave(reindexados.length > 0 ? "GUARDAR" : "NUEVA");
        // Rev 6: eliminar implica seguir editando; el finado previo deja
        // EDITAR+bloqueo y aquí se regresa a GUARDAR desbloqueado.
        setIsEdicionBloqueada(false);
        if (reindexados.length === 0) { limpiarSucio(); }
        else marcarSucio();
        focusLectorCodigoBarras();
    };
    const limpiarSinExistencias = () => {
        setListaSinExistencias([]);
    };

    const reiniciarCaptureIndex = () => {
        captureIndexRef.current = 1;
    };

    // Rev 1: elimina SQL + buffer Redis (conserva ctx origen/destino/folio).
    // Rev 6: no se fina antes (se va a borrar todo); se limpia dirty.
    // Rev 10 (port tenant): invalida cola (generación) + verifica lista vacía,
    // todo vía RequestContext, sin fetch directo.
    const handleEliminaTraslado = async () => {
        if (movimientoBloqueado) return;
        await esperarColaScans(3000);
        avanzarGeneracionFolio();
        setListaTrasladosData([]);
        listaTrasladosDataRef.current = [];
        setPartidaTrasladoSeleccionada(null);
        reiniciarCaptureIndex();
        limpiarSinExistencias();
        limpiarSucio();
        setIsTrasladoBlocked(false);
        setIsEdicionBloqueada(false);
        setStatusTraslado("PE");
        setTitleActionSave("NUEVA");
        try {
            const url = apiTrasladosEliminaTrasladoPC.replace("{pc}", pc);
            await DeleteRequest({ url });
        } catch {}
        try {
            const urlBuf = apiTrasladosCapturaEliminarTodo.replace("{pc}", encodeURIComponent(pc.trim()));
            await DeleteRequest({ url: urlBuf });
        } catch {}
        // Rev 10 (port tenant): verificar vacío vía RequestContext; reintento
        // si quedaron deltas huérfanos (RequestContext, sin fetch directo).
        try {
            const rows = await cargarListaTraslados({ silent: true });
            if (rows && rows.length > 0) {
                try {
                    const urlBuf = apiTrasladosCapturaEliminarTodo.replace("{pc}", encodeURIComponent(pc.trim()));
                    await DeleteRequest({ url: urlBuf });
                } catch {}
                await cargarListaTraslados({ silent: true });
            }
        } catch {}
        focusLectorCodigoBarras();
    };

    // Rev 1 (23/09/2026): Nuevo fina en SQL, incrementa el folio y libera
    // Redis para la nueva captura. Nada se pierde: el buscador por máquina
    // conserva pendientes PE y aplicados TR.
    // Rev 5 (26/09/2026): Nuevo NO usa el modal de progreso (0-99). Ese modal
    // es exclusivo de Aplicar. Aquí solo loader puntual de folio.
    // Rev 11: Nuevo desde vista bloqueada (TR/CA) libera vista + Redis y pide
    // folio disponible. Antes dependía solo de traslados/nuevo con el folio
    // viejo visto: si el backend devolvía error/mismo folio, se abortaba sin
    // limpiar ni pedir foliotraslado/{pc}.
    const handleNuevoTraslado = async () => {
        // Rev 10 (port tenant): drenar cola + finado SILENCIOSO antes de
        // cambiar de folio; todo vía RequestContext, sin fetch directo.
        await esperarColaScans();
        // Rev 11: rama vista bloqueada (TR/CA). No hay nada que finar
        // (guard central es no-op en bloqueado); se libera vista + buffer y
        // se pide folio disponible como fuente autoritativa.
        if (movimientoBloqueado) {
            avanzarGeneracionFolio();
            const origenBloq = almacenExhibidorOrigen?.nombre?.trim() || "";
            const destinoBloq = almacenExhibidorDestino?.nombre?.trim() || "";
            setOpenProgressModal(false);
            setTotalRegistrosProgress(0);
            try {
                setListaTrasladosData([]);
                listaTrasladosDataRef.current = [];
                setPartidaTrasladoSeleccionada(null);
                limpiarSinExistencias();
                reiniciarCaptureIndex();
                sortedDataRef.current = [];
                posNavRef.current = -1;
                setIsTrasladoBlocked(false);
                setIsEdicionBloqueada(false);
                setStatusTraslado("PE");
                limpiarSucio();
                setTitleActionSave("NUEVA");
                try {
                    const urlBuf = apiTrasladosCapturaEliminarTodo.replace("{pc}", encodeURIComponent(pc.trim()));
                    await DeleteRequest({ url: urlBuf });
                } catch {}
                try {
                    const urlDel = apiTrasladosEliminaTrasladoPC.replace("{pc}", pc);
                    await DeleteRequest({ url: urlDel });
                } catch {}
                let folioNuevo = 0;
                try {
                    const result = await PostRequest({
                        url: apiTrasladosNuevo,
                        body: { pc: pc.trim(), usuario },
                        loader: "Creando nuevo folio de traslado...",
                    });
                    if (!result?.hasError && !result?.HasError && Number(result?.result)) {
                        folioNuevo = Number(result.result);
                    }
                } catch {}
                if (folioNuevo > 0) {
                    try {
                        await PostRequest({
                            url: apiLimpiezaNuevo,
                            body: { tipo: "TRASLADO", folio: folioNuevo, pc: pc.trim() },
                        });
                    } catch {}
                }
                // Folio disponible manda (cubre nuevo fallido o mismo folio).
                try {
                    const respFolio = await GetRequest({
                        url: apiFolioDisponibleTraslados.replace("{pc}", pc),
                        loader: "Obteniendo folio disponible...",
                    });
                    if (!respFolio?.HasError && !respFolio?.hasError && Number(respFolio?.result)) {
                        folioNuevo = Number(respFolio.result);
                    }
                } catch {}
                await limpiarBufferRedisTraslados();
                setListaTrasladosData([]);
                listaTrasladosDataRef.current = [];
                if (folioNuevo > 0) {
                    setFolioTraslado(folioNuevo);
                    await guardarCtxTraslados(origenBloq, destinoBloq, folioNuevo);
                    handleOpenAlert(`Vista liberada. Nuevo folio de traslado: ${folioNuevo}`, "OK");
                } else {
                    await guardarCtxTraslados(origenBloq, destinoBloq, 0);
                    handleOpenAlert("Vista liberada. Verifique el folio disponible.", "OK");
                }
            } finally {
                setOpenProgressModal(false);
                focusLectorCodigoBarras();
            }
            return;
        }
        // Rev 6: finar antes de nuevo (igual que Salidas); aborta si falla.
        if (!(await guardarTrasladoSiHayCambios({ silent: true }))) return;
        avanzarGeneracionFolio();
        const origen = almacenExhibidorOrigen?.nombre?.trim() || "";
        const destino = almacenExhibidorDestino?.nombre?.trim() || "";
        await guardarCtxTraslados(origen, destino, folioTraslado);
        setOpenProgressModal(false);
        setTotalRegistrosProgress(0);
        try {
            const result = await PostRequest({
                url: apiTrasladosNuevo,
                body: { pc: pc.trim(), usuario },
                loader: "Creando nuevo folio de traslado...",
            });
            if (result?.hasError || result?.HasError) {
                handleOpenAlert("Error al crear nuevo traslado: " + (result?.message || "Error desconocido"));
                return;
            }
            const folioNuevo = Number(result?.result) || 0;
            // Limpieza del folio nuevo obtenido (SQL + Redis por folio+PC,
            // aislado por tenant). El flujo sigue igual.
            if (folioNuevo > 0) {
                try {
                    await PostRequest({
                        url: apiLimpiezaNuevo,
                        body: { tipo: "TRASLADO", folio: folioNuevo, pc: pc.trim() },
                    });
                } catch {}
            }
            // Rev 10 (port tenant): limpieza explícita del buffer vía
            // RequestContext + verificación de lista vacía (sin fetch).
            await limpiarBufferRedisTraslados();
            setListaTrasladosData([]);
            listaTrasladosDataRef.current = [];
            setPartidaTrasladoSeleccionada(null);
            limpiarSinExistencias();
            reiniciarCaptureIndex();
            sortedDataRef.current = [];
            posNavRef.current = -1;
            setIsTrasladoBlocked(false);
            setIsEdicionBloqueada(false);
            setStatusTraslado("PE");
            limpiarSucio();
            if (folioNuevo > 0) {
                setFolioTraslado(folioNuevo);
                await guardarCtxTraslados(origen, destino, folioNuevo);
            }
            setTitleActionSave("NUEVA");
            handleOpenAlert(`Captura anterior guardada. Nuevo folio de traslado: ${folioNuevo}`, "OK");
        } finally {
            setOpenProgressModal(false);
            focusLectorCodigoBarras();
        }
    };

    // Rev 9 (port tenant): PDF en OTRA PESTAÑA vía RequestContext.
    // GetFileRequest del tenant soporta openInNewTab nativo (abre la pestaña
    // con el PDF); si el popup se bloquea, el propio RequestContext avisa.
    const abrirVistaPreviaTrasladoNuevaPestana = async () => {
        const urlSend = apiImprimirTraslado.replace("{pc}", pc.trim());
        return await GetFileRequest({ url: urlSend, openInNewTab: true, loader: "Generando vista previa..." });
    };

    // Rev 9 (port tenant): comprobante post-aplicar en otra pestaña. Primero
    // el ticket por PC; si ya no existe (folio TR + buffer limpio), fallback
    // al reporte por periodo SQL del día (misma fuente que Historial del día).
    const abrirComprobanteAplicadoNuevaPestana = async ({ origen, destino }) => {
        const urlSend = apiImprimirTraslado.replace("{pc}", pc.trim());
        const ok = await GetFileRequest({ url: urlSend, openInNewTab: true, loader: "Generando comprobante..." });
        if (ok) return true;
        try {
            const hoy = getFechaLocalCorta();
            const body = {
                fechainicio: hoy,
                fechafin: hoy,
                almacenorigen: String(origen || "TODOS").trim().toUpperCase() || "TODOS",
                almacendestino: String(destino || "TODOS").trim().toUpperCase() || "TODOS",
                filtrodescripcion: "",
                sucursal: parametrosCajaForm?.sucursal ?? "",
                pc: (parametrosCajaForm?.caja || "").trim(),
                usuario: usuario || "",
                tipousuario: tipoUsuario || "USUARIO",
            };
            return await PostFileRequest({ url: apiReporteTrasladosPeriodo, body, openInNewTab: true, loader: "Generando comprobante..." });
        } catch {
            return false;
        }
    };

    const getFechaLocalCorta = (date = new Date()) => {
        const d = date instanceof Date ? date : new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    // Rev 8: obtiene el PDF del traslado pendiente por PC (misma fuente que
    // usaba la vista previa: GET imprimirtraslado/{pc}).
    // Rev 9 (port tenant): reemplazado por abrirVistaPreviaTrasladoNuevaPestana
    // y abrirComprobanteAplicadoNuevaPestana (GetFile/PostFileRequest
    // openInNewTab, 100% RequestContext). Se conserva getFechaLocalCorta
    // para el fallback por periodo SQL.

    // Rev 1: imprimir fina primero para que el PDF salga con lo capturado.
    // Rev 6: el PDF se genera desde SQL, por eso el finado previo es vital:
    // Redis y tabla quedan con lo mismo antes de imprimir.
    // Rev 9 (port tenant): finado SILENCIOSO + PDF en otra pestaña vía
    // GetFileRequest openInNewTab (como los demés reportes del tenant).
    const handleMostrarVistaPrevia = async () => {
        if (!(await guardarTrasladoSiHayCambios({ silent: true }))) return;
        await abrirVistaPreviaTrasladoNuevaPestana();
        focusLectorCodigoBarras();
    };

const handleGuardarTraslado = async (opts = {}) => {
        // Rev 10 (port tenant): mutex anti doble-finado (autofinado vs
        // Nuevo/Aplicar). Solo memoria; la red sigue 100% RequestContext.
        if (guardandoRef.current) {
            for (let i = 0; i < 50 && guardandoRef.current; i++) {
                await new Promise((r) => setTimeout(r, 100));
            }
            if (guardandoRef.current) return false;
        }
        guardandoRef.current = true;
        try {
        const {
            folio = folioTraslado,
            items = (listaTrasladosDataRef.current ?? listaTrasladosData),
            origen: origenOverride,
            destino: destinoOverride,
            mensajeExito = "Traslado guardado correctamente",
            silent = false,
        } = opts;

        const origen = (origenOverride ?? almacenExhibidorOrigen?.nombre)?.trim();
        const destino = (destinoOverride ?? almacenExhibidorDestino?.nombre)?.trim();

        if (!origen || !destino) {
            handleOpenAlert("Seleccione almacén origen y destino");
            guardandoRef.current = false;
            return false;
        }
        if (origen.toUpperCase() === destino.toUpperCase()) {
            handleOpenAlert("El origen y destino no pueden ser iguales");
            guardandoRef.current = false;
            return false;
        }

        if (!items.length) {
            if (!silent) handleOpenAlert("No hay artículos para guardar");
            guardandoRef.current = false;
            return false;
        }
        // Rev 6: en TR/CA no se guarda nada (igual que Salidas).
        if (movimientoBloqueado) { guardandoRef.current = false; return true; }
        // Rev 9: sin cambios no hay nada que finar. El explícito pasa a
        // EDITAR estable (sin llamar al backend) para no provocar el ciclo
        // "No hay registros para guardar" -> GUARDAR -> guardar -> error.
        if (!dirtyRef.current) {
            if (silent) { guardandoRef.current = false; return true; }
            try { await guardarCtxTraslados(origen, destino, Number(folio) || 0); } catch {}
            limpiarSucio();
            setTitleActionSave("EDITAR");
            setIsEdicionBloqueada(true);
            guardandoRef.current = false;
            return true;
        }

        // Rev 1: el backend fina buffer+items a SQL (folio PE) y recorta el buffer.
        // Rev 5 (26/09/2026): Guardar NO usa el modal de progreso (0-99, solo
        // de Aplicar). Explícito = loader puntual; silencioso = sin UI.
        // Rev 6 (03/10/2026): se envían TODOS los items (SQL + pendientes).
        // Antes solo iban los temporales (id<=0): si la lista venía de SQL
        // (folio PE cargado del buscador o recarga), el body quedaba vacío,
        // el backend devolvía "No hay partidas...", el guardado fallaba y el
        // título se quedaba en GUARDAR, dejando Aplicar deshabilitado.
        try {
            const body = {
                pc,
                usuario,
                folio: Number(folio) || 0,
                almacenexhibidororigen: origen,
                almacenexhibidordestino: destino,
                items: items
                    .map(i => ({
                        clavearticulo: i.clavearticulo,
                        descripcion: i.descripcion,
                        medida: i.medida,
                        cantidad: i.cantidad,
                    }))
            };

            const result = await PostRequest({
                url: apiTrasladosGuardarTemporales,
                body,
                loader: silent ? undefined : "Guardando traslado...",
            });

            if (result?.HasError || result?.hasError) {
                const msgBackend = String(result?.message || "Error desconocido");
                // Rev 9: si el buffer ya esté vacío pero la tabla tiene filas
                // (todo ya finado en SQL), el backend responde "No hay
                // partidas/registros". No es error real: se sincroniza a
                // EDITAR estable en vez de dejar GUARDAR en bucle.
                if (/no hay (partidas|art.+|registros)/i.test(msgBackend) && items.length > 0) {
                    if (silent) { limpiarSucio(); return true; }
                    try { await cargarListaTraslados(); } catch {}
                    limpiarSucio();
                    setTitleActionSave("EDITAR");
                    setIsEdicionBloqueada(true);
                    return true;
                }
                if (!silent) handleOpenAlert("Error al guardar traslado: " + msgBackend);
                return false;
            }

            // Rev 2 (23/09/2026): solo el guardado explícito deja EDITAR y
            // bloquea edición. El silencioso no toca título/bloqueo/recarga:
            // cualquier cambio (lector, buscador, cantidades, eliminar)
            // mantiene GUARDAR habilitado.
            // Rev 6: ambos limpian dirty (ya quedó finado en SQL + Redis).
            if (silent) { limpiarSucio(); return true; }
            await guardarCtxTraslados(origen, destino, Number(folio) || 0);
            await cargarListaTraslados();
            limpiarSucio();
            setTitleActionSave("EDITAR");
            setIsEdicionBloqueada(true);
            handleOpenAlert(mensajeExito, "OK");
            return true;
        } catch (error) {
            if (!silent) handleOpenAlert("Error al guardar traslado: " + (error?.message || "Error desconocido"));
            return false;
        } finally {
            guardandoRef.current = false;
        }
        } catch {
            guardandoRef.current = false;
            return false;
        }
    };

    const handleToggleGuardarEditar = async () => {
        if (movimientoBloqueado) return;
        if (titleActionSave === "EDITAR") {
            setIsEdicionBloqueada(false);
            setTitleActionSave("GUARDAR");
            marcarSucio();
            focusLectorCodigoBarras();
            return;
        }
        // Rev 9: en GUARDAR sin cambios no se llama al backend (ver
        // handleGuardarTraslado): pasa a EDITAR estable sin error.
        const guardado = await handleGuardarTraslado();
        if (guardado) {
            setIsEdicionBloqueada(true);
        }
        focusLectorCodigoBarras();
    };

    // Rev 6: guard central estilo Salidas (guardarSalidaSiHayCambios). Un solo
    // finado Redis→SQL antes de aplicar/imprimir/nuevo/salir/cambio de folio.
    // Es no-op si TR/CA, si no esté en GUARDAR, si no hay partidas o si no
    // hay cambios (dirty). El aplicado e impresión leen desde SQL, nunca
    // desde Redis.
    const guardarTrasladoSiHayCambios = async (opts = {}) => {
        if (movimientoBloqueado || isTrasladoBlocked) return true;
        if (titleActionSave !== "GUARDAR") return true;
        if (!dirtyRef.current) return true;
        const items = listaTrasladosDataRef.current;
        if (!items || items.length === 0) return true;
        return await handleGuardarTraslado({ silent: !!opts.silent });
    };

    // Rev 4: igual que entradas/salidas, aplicar fina primero Redis→SQL
    // (autoguardado) y luego aplica agrupado por artículo+medida.
    // Rev 9 (port tenant): finado SILENCIOSO + validación de conteo
    // Redis/SQL + modal de progreso 0-99 visible durante el aplicar +
    // comprobante en pestaña nueva vía RequestContext.
    const handleValidarYAplicar = async (status) => {
        if (!status) return;
        if (movimientoBloqueado) return;

        // Rev 10 (port tenant): drenar cola antes de congelar el working set.
        await esperarColaScans();
        // 1) Finar lo último de Redis a SQL sin UI (no bloquea el flujo).
        if (!(await guardarTrasladoSiHayCambios({ silent: true }))) return;

        const origen = almacenExhibidorOrigen?.nombre?.trim();
        const destino = almacenExhibidorDestino?.nombre?.trim();

        if (!origen || !destino) {
            handleOpenAlert("Seleccione almacén origen y destino");
            return;
        }
        if (origen.toUpperCase() === destino.toUpperCase()) {
            handleOpenAlert("El origen y destino no pueden ser iguales");
            return;
        }

        // 2) Validar que SQL tenga lo último de Redis: recargar y comparar
        // conteos. Si difieren, se adopta lo del servidor y se pide reintentar
        // para no aplicar un corte desfasado ni perder registros.
        const itemsPrevios = listaTrasladosDataRef.current || [];
        if (!itemsPrevios.length) {
            handleOpenAlert("No hay artículos para aplicar");
            return;
        }
        try {
            const rowsSrv = await cargarListaTraslados({ silent: true });
            const nSrv = Array.isArray(rowsSrv) ? rowsSrv.length : 0;
            if (nSrv !== itemsPrevios.length) {
                handleOpenAlert(
                    `El conteo cambió al sincronizar con el servidor (local ${itemsPrevios.length} vs servidor ${nSrv}). Se actualizó la lista; verifique y vuelva a aplicar.`
                );
                return;
            }
        } catch {}
        const items = listaTrasladosDataRef.current || [];
        if (!items.length) {
            handleOpenAlert("No hay artículos para aplicar");
            return;
        }

        // Rev 1: validar existencias antes de aplicar; si hay desfase se
        // bloquea y se detallan las partidas (decisión de negocio).
        try {
            const urlVal = apiTrasladosValidar.replace("{pc}", encodeURIComponent(pc.trim()));
            const valResp = await GetRequest({ url: urlVal });
            const validacion = Array.isArray(valResp?.result) ? valResp.result : [];
            const desfasadas = validacion.filter((v) => !v.ok);
            if (desfasadas.length > 0) {
                const detalle = desfasadas
                    .map((v) => `${v.clavearticulo} med ${v.medida}: solicitado ${v.solicitado}, existencia ${v.existencia} en ${v.almacen}`)
                    .join("\n");
                handleOpenAlert(`No se puede aplicar: partidas sin existencia suficiente:\n${detalle}`);
                setListaSinExistencias(desfasadas.map((v) => ({
                    clavearticulo: v.clavearticulo || "",
                    descripcion: v.descripcion || "",
                    medida: v.medida || "",
                    solicitado: v.solicitado || 0,
                    existenciaorigen: v.existencia || 0,
                })));
                return;
            }
        } catch {}

        // 3) Mostrar el modal de avance 0-99 ANTES del POST y darle un ciclo
        // de pintado para que sí se vea (antes el loader del PDF lo tapaba y
        // el guard explícito abortaba el flujo con "No hay registros").
        // Port tenant: sin pre-generación de blob; el comprobante se abre
        // post-aplicar por PC con fallback a periodo SQL (todo RequestContext).
        setTotalRegistrosProgress(items.length);
        setOpenProgressModal(true);
        await new Promise((r) => setTimeout(r, 120));

        try {
            // Rev 6 (03/10/2026): el backend aplica desde SQL (PE del folio),
            // se envía la lista completa como referencia (sin filtrar por id).
            const body = {
                pc,
                usuario,
                folio: folioTraslado,
                almacenexhibidororigen: origen,
                almacenexhibidordestino: destino,
                items: items
                    .map(i => ({
                        clavearticulo: i.clavearticulo,
                        descripcion: i.descripcion,
                        medida: i.medida,
                        cantidad: i.cantidad,
                    }))
            };

            // Sin loader global: el progreso lo muestra el modal 0-99.
            const result = await PostRequest({
                url: apiTrasladosAplicarMasivo,
                body,
            });

            setOpenProgressModal(false);

            if (result?.HasError || result?.hasError) {
                handleOpenAlert("Error al aplicar traslado: " + (result?.message || "Error desconocido"));
                return;
            }

            // Rev 1: el backend marcó TR el folio aplicado (buscador por
            // méquina); aquí solo se limpia estado + buffer, sin historial SQL.
            // Rev 10 (port tenant): el folio NUEVO nace PE desbloqueado (antes
            // quedaba TR bloqueado); buffer limpio verificado vía
            // RequestContext, sin fetch directo. Generación avanzada para
            // descartar scans viejos.
            avanzarGeneracionFolio();
            setListaTrasladosData([]);
            listaTrasladosDataRef.current = [];
            setPartidaTrasladoSeleccionada(null);
            sortedDataRef.current = [];
            posNavRef.current = -1;
            limpiarSucio();
            reiniciarCaptureIndex();
            limpiarSinExistencias();

            await limpiarBufferRedisTraslados();

            // Rev 9 (port tenant): comprobante en OTRA PESTAÑA vía
            // RequestContext (GET por PC + fallback POST periodo SQL).
            await abrirComprobanteAplicadoNuevaPestana({ origen, destino });

            const responseFolio = await GetRequest({
                url: apiFolioDisponibleTraslados.replace("{pc}", pc),
                loader: "Obteniendo nuevo folio de traslados...",
            });
            if (!responseFolio?.HasError && !responseFolio?.hasError && responseFolio?.result) {
                const folioNuevo = Number(responseFolio.result);
                setFolioTraslado(folioNuevo);
                await guardarCtxTraslados(
                    almacenExhibidorOrigen?.nombre || "",
                    almacenExhibidorDestino?.nombre || "",
                    folioNuevo
                );
            }

            // Rev 10 (port tenant): trabajo nuevo PE desbloqueado de inmediato.
            setStatusTraslado("PE");
            setIsTrasladoBlocked(false);
            setIsEdicionBloqueada(false);
            setTitleActionSave("NUEVA");
            const advertencias = result?.result?.advertenciasSincronizacion || result?.result?.lstAdvertenciasSincronizacion || [];
            if (Array.isArray(advertencias) && advertencias.length > 0) {
                handleOpenAlert(`Traslado aplicado con advertencias de sincronización:\n${advertencias.join("\n")}`);
            } else {
                handleOpenAlert("Traslado aplicado correctamente", "OK");
            }
        } catch (error) {
            setOpenProgressModal(false);
            handleOpenAlert("Error al aplicar traslado: " + (error?.message || "Error desconocido"));
        }
    };

    const handleRefresh = async () => {
        // Rev 6: refrescar fina en silencio para no perder captura.
        await guardarTrasladoSiHayCambios({ silent: true });
        focusLectorCodigoBarras();
    };

    // Rev 6: salir fina primero (igual que Salidas) para no perder registros.
    const handleSalirTraslados = async () => {
        await guardarTrasladoSiHayCambios({ silent: true });
        handleClickRegresarMainDashboard();
    };

    const listaAlmacenesExhibidoresOrdenada = listaAlmacenesExhibidoresGeneral?.slice().sort((c, d) => c.almacenexhibidor.localeCompare(d.almacenexhibidor));

    let listaAlmacenesExhibidoresAutoComplete = [];
    listaAlmacenesExhibidoresOrdenada.map((y) =>
        listaAlmacenesExhibidoresAutoComplete.push({
            id: y.id,
            nombre: y.almacenexhibidor.trim(),
        })
    );

    useEffect(() => {
        if (listaAlmacenesExhibidoresGeneral.length === 0) {
            handleObtenerAlmacenesExhibidores("GENERAL");
        }
    }, []);



    const totalArticulosTraslado = useMemo(() =>
        listaTrasladosData.reduce((acc, r) => acc + (Number(r.cantidad) || 0), 0),
        [listaTrasladosData]
    );

    // Rev 7: si la lista se vacía, limpiar el orden visible y el índice.
    useEffect(() => {
        if (!listaTrasladosData || listaTrasladosData.length === 0) {
            sortedDataRef.current = [];
            posNavRef.current = -1;
        }
    }, [listaTrasladosData]);

    // Rev 7: cada registro nuevo/selección se centra a media ventana.
    useEffect(() => {
        if (!partidaTrasladoSeleccionada) return;
        // Sincronizar índice con el orden visible antes de desplazar.
        try {
            const orden = ordenVisible();
            const idx = orden.findIndex((r) => r && partidaTrasladoSeleccionada && r.id === partidaTrasladoSeleccionada.id);
            if (idx >= 0) posNavRef.current = idx;
        } catch {}
        requestAnimationFrame(() => desplazarFilaSeleccionada(true));
        const timer = setTimeout(() => desplazarFilaSeleccionada(true), 150);
        return () => clearTimeout(timer);
    }, [partidaTrasladoSeleccionada]);

    useEffect(() => {
        const handleKeyDown = async (event) => {
            if (!event.altKey && !event.ctrlKey && !event.metaKey && event.key?.trim().toUpperCase() === 'F4') {
                event.preventDefault();
                event.stopPropagation();
                await handleSalirTraslados();
            }

if (event.altKey && event.key.trim().toUpperCase() === 'F1') {
                event.preventDefault();
                event.stopPropagation();
                if (isTrasladoBlocked || isEdicionBloqueada || movimientoBloqueado) return;
                setMostrarBuscadorArticulos(true);
                await handleAbrirModalBuscarArticulos();
                focusFiltroBuscadorArticulos();
            }

            if (event.altKey && event.key.trim().toUpperCase() === 'F7') {
                event.preventDefault();
                event.stopPropagation();
                if (isTrasladoBlocked || isEdicionBloqueada || movimientoBloqueado) return;
                if (listaTrasladosData.length && partidaTrasladoSeleccionada) {
                    await handleEliminaPartidaTrasladoCaja(partidaTrasladoSeleccionada);
                    focusLectorCodigoBarras();
                }
            }

            if (event.altKey && event.key.trim().toUpperCase() === 'F12') {
                event.preventDefault();
                event.stopPropagation();
                if (isTrasladoBlocked || isEdicionBloqueada || movimientoBloqueado) return;
                if (listaTrasladosData.length) {
                    setOpenConfirmEliminarTraslado(true);
                }
            }

            if (event.altKey && event.key.trim().toUpperCase() === 'A') {
                event.preventDefault();
                event.stopPropagation();
                if (movimientoBloqueado) return;
                if (listaTrasladosData.length) handleAbrirValidarAccesoTraslados();
            }

            const target = event.target;
            const isInput = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
            if (isInput) return;

            // Rev 7: flechas sobre el ORDEN VISIBLE (tras click en columnas).
            // Se reindexa vía posNavRef/aplicarOrdenVisible para no alterar
            // datos al desplazarse. Si la tabla ya consumió la flecha
            // (defaultPrevented por su handleRowKeyDown), no avanzar de nuevo
            // para no brincar de 2 en 2.
            const orden = ordenVisible();

            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                if (event.defaultPrevented) return;
                event.preventDefault();
                if (!orden || orden.length === 0) return;
                let pos = posNavRef.current;
                if (typeof pos !== 'number' || pos < 0 || pos >= orden.length) {
                    pos = orden.findIndex(item => partidaTrasladoSeleccionada && item.id === partidaTrasladoSeleccionada.id);
                    if (pos < 0) pos = event.key === 'ArrowDown' ? -1 : 0;
                }
                let newIndex;
                if (event.key === 'ArrowDown') {
                    newIndex = pos < orden.length - 1 ? pos + 1 : pos;
                } else {
                    newIndex = pos > 0 ? pos - 1 : 0;
                }
                posNavRef.current = newIndex;
                if (orden[newIndex]) {
                    setPartidaTrasladoSeleccionada(orden[newIndex]);
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [partidaTrasladoSeleccionada, listaTrasladosData, isEdicionBloqueada, movimientoBloqueado]);

    // Rev 6: autofinado silencioso cada 45s (esténdar Salidas) con dirty flag:
    // solo dispara si hubo cambios; sin cambios no hace nada (desactivado).
    // El silencioso no toca título/bloqueo/recarga ni interrumpe el escaneo.
    // Tabla SQL y Redis quedan con lo mismo antes de imprimir/aplicar.
    const flushSilenciosoRef = useRef(null);
    flushSilenciosoRef.current = () => {
        if (movimientoBloqueado || isEdicionBloqueada || isTrasladoBlocked) return Promise.resolve(true);
        if (titleActionSave !== "GUARDAR") return Promise.resolve(true);
        if (!dirtyRef.current) return Promise.resolve(true);
        if (!listaTrasladosDataRef.current || listaTrasladosDataRef.current.length === 0) return Promise.resolve(true);
        return handleGuardarTraslado({ silent: true }).catch(() => false);
    };
    useEffect(() => {
        const timer = setInterval(() => {
            try { flushSilenciosoRef.current?.(); } catch {}
        }, AUTOFINADO_MS);
        return () => clearInterval(timer);
    }, []);
    useEffect(() => () => {
        try {
            const p = flushSilenciosoRef.current?.();
            if (p && typeof p.catch === "function") p.catch(() => {});
        } catch {}
    }, []);
    // Rev 10 (port tenant): SIN fetch directo en pagehide. El tenant cifra
    // todo por RequestContext (JWE + retry-401 + loader); un fetch crudo con
    // Bearer rompería el canal y el backend lo rechaza. El finado al ocultar
    // lo cubren el autofinado 45s + el flush de unmount de arriba
    // (flushSilenciosoRef, RequestContext) + el aviso beforeunload.
    // No se registra listener de pagehide a propósito.

    // Rev 6: aviso al cerrar/recargar con cambios sin finar (igual que Salidas).
    useEffect(() => {
        const advertirPendientes = (e) => {
            if (movimientoBloqueado || isTrasladoBlocked) return;
            if (titleActionSave !== "GUARDAR") return;
            if (!dirtyRef.current) return;
            const items = listaTrasladosDataRef.current;
            if (!items || items.length === 0) return;
            e.preventDefault();
            e.returnValue = "";
        };
        window.addEventListener("beforeunload", advertirPendientes);
        return () => window.removeEventListener("beforeunload", advertirPendientes);
    }, [movimientoBloqueado, isTrasladoBlocked, titleActionSave]);

    // Rev 1: buscador de traslados por méquina (PE se cargan, TR solo vista).
    // Rev 4: antes de cambiar de folio se fina Redis→SQL (cada acción guarda;
    // el aplicar trabaja desde SQL, nunca desde Redis).
    const [openBuscarTraslados, setOpenBuscarTraslados] = useState(false);
    // Rev 6: solo PE se cargan (TR es solo vista en el modal). Antes de
    // cambiar de folio se fina Redis→SQL con el guard central.
    // Rev 11: no sobrescribir TR/CA a PE. Si el folio cargado resulta TR/CA
    // se fuerza modo bloqueado EDITAR solo-lectura; si es PE se conserva el
    // mismo folio editable para seguir capturando y aplicar. Si viene vacío
    // se resetea a PE/NUEVA desbloqueado.
    const handleSelectFolioTraslado = async (folio) => {
        const folioNum = Number(folio) || 0;
        if (!folioNum) return;
        await esperarColaScans();
        if (!(await guardarTrasladoSiHayCambios({ silent: true }))) return;
        // Rev 10 (port tenant): al cambiar de folio se descarta lo encolado
        // del anterior (RequestContext; sin fetch directo).
        avanzarGeneracionFolio();
        setOpenBuscarTraslados(false);
        await guardarCtxTraslados(
            almacenExhibidorOrigen?.nombre || "",
            almacenExhibidorDestino?.nombre || "",
            folioNum
        );
        setFolioTraslado(folioNum);
        const rows = await cargarListaTraslados();
        if (rows.length > 0) {
            const primero = rows[0];
            if (primero.almacenexhibidororigen) setAlmacenExhibidorOrigen({ nombre: String(primero.almacenexhibidororigen).trim() });
            if (primero.almacenexhibidordestino) setAlmacenExhibidorDestino({ nombre: String(primero.almacenexhibidordestino).trim() });
            const stSel = String(
                primero?.statusentradasalida
                ?? primero?.statustraslado
                ?? primero?.status
                ?? primero?.sStatusTraslado
                ?? "PE"
            ).trim().toUpperCase() || "PE";
            if (stSel === "TR" || stSel === "CA") {
                setStatusTraslado(stSel);
                setTitleActionSave("EDITAR");
                setIsEdicionBloqueada(true);
                setIsTrasladoBlocked(false);
            } else {
                setTitleActionSave("GUARDAR");
                setIsEdicionBloqueada(false);
                setIsTrasladoBlocked(false);
                setStatusTraslado("PE");
                limpiarSucio();
            }
        } else {
            setListaTrasladosData([]);
            listaTrasladosDataRef.current = [];
            setPartidaTrasladoSeleccionada(null);
            reiniciarCaptureIndex();
            sortedDataRef.current = [];
            posNavRef.current = -1;
            setIsTrasladoBlocked(false);
            setIsEdicionBloqueada(false);
            setStatusTraslado("PE");
            limpiarSucio();
            setTitleActionSave("NUEVA");
        }
        focusLectorCodigoBarras();
    };

    const columnasTraslados = useMemo(() => [
        {
            hideSort: true,
            field: "deleteRow",
            width: 50,
            render: (row) => (
                <IconButton onClick={() => handleEliminaPartidaTrasladoCaja(row)}>
                    <DeleteIcon color="primary" />
                </IconButton>
            ),
        },
        { title: "#", field: "_captureIndex", width: 50 },
        { title: "Clave artículo", field: "clavearticulo", width: 150, render: (row) => (
            <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                {row.clavearticulo}
                <IconButton size="small" title="Copiar código de barras" aria-label="Copiar código de barras" sx={{ p: 0.25 }} onClick={(e) => { e.stopPropagation(); copiarTexto(row.codigobarras || row.codigoBarras || row.clavearticulo); }}>
                    <ContentCopy fontSize="inherit" sx={{ fontSize: 14 }} />
                </IconButton>
            </span>
        ) },
        { title: "Descripción", field: "descripcion", width: 350 },
        { title: "Medida", field: "medida", width: 100 },
        { title: "Origen", field: "almacenexhibidororigen" , width: 100 },
        { title: "Exis Orig", field: "existenciaorigen", width: 80 },
        { title: "Destino", field: "almacenexhibidordestino" , width: 100 },
        { title: "Exis Dest", field: "existenciadestino", width: 80 },
        { title: "Cantidad a trasladar", field: "cantidad" },
    ], []);

    const textoSinExistencias = useMemo(() =>
        listaSinExistencias.map(item =>
            `${item.clavearticulo} - ${item.descripcion} - ${item.medida} - Sol: ${item.solicitado ?? 0} - Exis: ${item.existenciaorigen ?? 0}`
        ).join('\n'),
        [listaSinExistencias]
    );

    return(
        <Fragment>
            <SizeSoftXLayoutForm
                titlePage="Traslados Entre Almacenes/Exhibidores"
                buttonActions={
                    <MnuTrasladosAlmacenesExhibidoresActions
                        onOpenBuscador={() => {
                            if (movimientoBloqueado) return;
                            setMostrarBuscadorArticulos(true);
                            handleAbrirModalBuscarArticulos();
                            setTimeout(focusFiltroBuscadorArticulos, 50);
                        }}
                        onAfterAction={focusLectorCodigoBarras}
                        onRefresh={handleRefresh}
                        onDeletePartida={(row) => handleEliminaPartidaTrasladoCaja(row)}
                        onDeleteTraslado={handleEliminaTraslado}
onNuevoTraslado={handleNuevoTraslado}
                        onGuardarTraslado={handleToggleGuardarEditar}
                        onAplicarTraslado={handleAbrirValidarAccesoTraslados}
                        onMostrarVistaPrevia={handleMostrarVistaPrevia}
                        onBuscarTraslados={() => setOpenBuscarTraslados(true)}
                        onSalir={handleSalirTraslados}
                        dataLength={listaTrasladosData.length}
                        isBlocked={isTrasladoBlocked}
                        isEditionLocked={isEdicionBloqueada}
                        titleActionSave={titleActionSave}
                        movimientoBloqueado={movimientoBloqueado}
                        statusTraslado={statusTrasladoNormalizado}
                    />
                }
            >
            <div className="header_traslados">
                <Autocomplete
                    freeSolo
                    noOptionsText={"Sin resultados"}
                    disableClearable
                    id="almacenexhibidororigen"
                    name="almacenexhibidororigen"
                    options={listaAlmacenesExhibidoresAutoComplete}
                    getOptionLabel={(option) => typeof option === "string" ? option : option.nombre}
                    isOptionEqualToValue={(option, value) =>
                        typeof value === "string"
                            ? option.nombre === value
                            : option.nombre === value?.nombre
                    }
                    value={almacenExhibidorOrigen}
                    onChange={handleChangeAlmacenexhibidorOrigen}
                    onInputChange={handleInputChangeAlmacenexhibidorOrigen}
onBlur={() => guardarAlmacenexhibidorOrigen(almacenExhibidorOrigen)}
                    disabled={isTrasladoBlocked || isEdicionBloqueada || movimientoBloqueado}
                    renderInput={(params) => (
                        <TextField {...params} label="Almacén o Exhibidor Orígenes:" required />
                    )}
                    sx={{ flex: '1 1 280px', minWidth: '200px' }}
                />
                <TextField autoComplete="off"
                    label="Folio"
                    value={folioTraslado || ""}
                    InputProps={{ readOnly: true }}
                    size="small"
                    sx={{ flex: '0 0 120px', minWidth: '100px' }}
                />
                <Autocomplete
                    freeSolo
                    noOptionsText={"Sin resultados"}
                    disableClearable
                    id="almacenexhibidordestino"
                    name="almacenexhibidordestino"
                    options={listaAlmacenesExhibidoresAutoComplete}
                    getOptionLabel={(option) => typeof option === "string" ? option : option.nombre}
                    isOptionEqualToValue={(option, value) =>
                        typeof value === "string"
                            ? option.nombre === value
                            : option.nombre === value?.nombre
                    }
                    value={almacenExhibidorDestino}
onChange={handleChangeAlmacenexhibidorDestino}
                    disabled={isTrasladoBlocked || isEdicionBloqueada || movimientoBloqueado}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Almacén o Exhibidor Destino:"
                            required
                            error={errorDestino}
                            helperText={errorDestino ? "El destino no puede ser igual al origen" : ""}
                        />
                    )}
                    sx={{ flex: '1 1 280px', minWidth: '200px' }}
                />
            </div>
            <div
                className="body_traslados"
                ref={tableRef}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    paddingBottom: '115px',
                }}
            >
                <Box sx={{ width: '100%', minWidth: 0 }}>
                    <SizeSoftXTableVentas
                        columns={columnasTraslados}
                        data={listaTrasladosData ?? []}
                        id="id"
                        row={partidaTrasladoSeleccionada}
                        setRow={handleRowClickTraslados}
                        fontSize="small"
                        showFilters={true}
                        disablePagination={true}
                        onSortChange={aplicarOrdenVisible}
                    />
                </Box>
                <Box sx={{
                    width: '100%',
                    minWidth: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '6px',
                }}>
                    <TextField autoComplete="off"
                        label="SIN EXISTENCIAS"
                        multiline
                        fullWidth
                        minRows={4}
                        maxRows={16}
                        value={textoSinExistencias}
                        InputProps={{ readOnly: true }}
                        variant="outlined"
                        size="small"
                        sx={{
                            flex: 1,
                            '& .MuiInputBase-root': {
                                backgroundColor: 'inherit',
                                fontFamily: 'monospace',
                                fontSize: '1.5rem',
                                lineHeight: 1.4,
                            },
                            '& .MuiInputBase-input': {
                                color: '#b71c1c',
                                fontWeight: 500,
                            },
                            '& .MuiInputLabel-root': {
                                color: '#b71c1c',
                                fontWeight: 600,
                            },
                        }}
                    />
                    <Box sx={{ display: 'flex', gap: '6px' }}>
                        <IconButton
                            size="small"
                            color="error"
                            onClick={limpiarSinExistencias}
                            disabled={listaSinExistencias.length === 0}
                            title="Limpiar lista de sin existencias"
                            sx={{ border: '1px solid rgba(0,0,0,0.12)', borderRadius: '6px', padding: '4px 12px', fontSize: '0.75rem' }}
                        >
                            Limpiar lista
                        </IconButton>
                    </Box>
                </Box>
            </div>
            <Box
                id="fixed-footer-traslados"
                sx={{
                    position: 'fixed',
                    bottom: '10px',
                    left: '20px',
                    right: '20px',
                    borderRadius: '12px',
                    zIndex: 1100,
                    backgroundColor: '#fff',
                    boxShadow: '0 -4px 20px rgba(0,0,0,0.15)',
                    display: 'flex',
                    flexWrap: 'nowrap',
                    alignItems: 'center',
                    gap: 2,
                    px: 3,
                    py: '8px',
                    borderTop: '1px solid #ddd',
                }}
            >
                <Box sx={{ flex: '1 1 auto' }}>
                    <SizeSoftXLectorCodigoBarrasEntradas
                        onColectorScan={handleColectorScanTraslados}
                        disabled={isTrasladoBlocked || isEdicionBloqueada || movimientoBloqueado}
                    />
                </Box>
                {/* Rev 9: Total registros = renglones (length, retotaliza solo:
                    0 vacío / 1 un renglón / N renglones). Total artículos =
                    suma de cantidades. El "#" es 1..N reindexado. */}
                <TextField autoComplete="off"
                    label="Total registros"
                    name="totalregistros"
                    value={listaTrasladosData.length}
                    InputProps={{ readOnly: true }}
                    size="small"
                    sx={{ flex: '0 0 140px' }}
                />
                <TextField autoComplete="off"
                    label="Total artículos"
                    name="totalarticulos"
                    value={totalArticulosTraslado}
                    InputProps={{ readOnly: true }}
                    size="small"
                    sx={{ flex: '0 0 140px' }}
                />
            </Box>
            {/* Rev 9: progreso 0-99 exclusivo de Aplicar.
                La vista previa y el comprobante abren en otra pestaña vía
                GetFile/PostFileRequest openInNewTab (RequestContext). */}
            <ModalStatusWaitingProcess
                open={openProgressModal}
                totalRegistros={totalRegistrosProgress}
                titulo="Aplicando traslado..."
                onClose={() => setOpenProgressModal(false)}
            />
            <SizeSoftXConfirmDialog
                open={openConfirmEliminarTraslado}
                title="Eliminar traslado"
                message="¿Desea eliminar todo el traslado actual?"
                handleConfirmDialog={(confirm) => {
                    setOpenConfirmEliminarTraslado(false);
                    if (confirm) {
                        handleEliminaTraslado();
                        focusLectorCodigoBarras();
                    }
                }}
            />
            <ModalBuscarArticulosParaVenta
                key={almacenExhibidorOrigen?.nombre || "sin-origen"}
                openModal={mostrarBuscadorArticulos && !movimientoBloqueado}
                handleCloseModal={() => {
                    setMostrarBuscadorArticulos(false);
                    handleCloseModalBuscarArticulos();
                }}
                dominio={almacenExhibidorOrigen?.nombre || ""}
                articuloSelect={handleArticuloSelecionado}
            />
            <ModalBuscarTraslados
                openModal={openBuscarTraslados}
                handleCloseModal={() => {
                    setOpenBuscarTraslados(false);
                    focusLectorCodigoBarras();
                }}
                pc={pc.trim()}
                onSelectFolio={handleSelectFolioTraslado}
            />
            <FrmLoginValidate
                openModal={openModalValidarAcceso}
                tiposUsuario={["SA", "ADMINISTRADOR", "SUPERVISOR"]}
                handleComandoEjecucion={handleValidarYAplicar}
                hancleCloseModalValidator={() => handleCerrarValidarAccesoTraslados()}
            />
            </SizeSoftXLayoutForm>
        </Fragment>
    );
}
